import { isPossiblePhoneNumber } from 'libphonenumber-js';

export const validateInput = (value: string): boolean => {
    if (value.length === 0) {
        return false;
    }
    return true;
};

export const validateMultiSelectInput = (value:string[]): boolean =>{
    if (value.length === 0) {
        return false;
    }
    return true;
}

export const validateEmailInput = (value: string): boolean => {
    if (value.length === 0) {
        return false;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
};

export const validatePhoneNumberInput = (value: string): boolean => {
    if (value.length === 0) {
        return false;
    }

    // Prepend '+' if not present
    const formattedValue = value.startsWith('+') ? value : `+${value}`;
    return isPossiblePhoneNumber(formattedValue);
};